module.exports = __webpack_public_path__ + "static/media/community-master.836955bc.glb";